import axios from 'axios'
import { GERAR_PIX_FECHAMENTO_CAIXA } from '../../types'
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil'
import { URL } from '../../../util/ambienteActions';

export default function gerarPixFechamentoCaixa (fechamentoCaixaId, codigoEmpresa) {
  const url = `${URL}/fechamento-caixa-usuario/${fechamentoCaixaId}/empresa/${codigoEmpresa}/gerar-pix`;
  return dispatch => axios.post(url, {}, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: GERAR_PIX_FECHAMENTO_CAIXA,
        payload: response
      })
  );
}
